(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[461],{

/***/ 7288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_ButtonWithIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(71800);
// EXTERNAL MODULE: ./src/components/atoms/Icon/index.tsx + 38 modules
var Icon = __webpack_require__(34876);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/molecules/ButtonWithIcon/styled.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-xgnlex-0"
})(["display:flex;gap:", ";justify-content:center;text-align:center;", ""], function (props) {
  return props.noText ? "4px;" : "8px";
}, function (props) {
  return props.rightIcon ? (0,styled_components_browser_esm/* css */.iv)(["flex-direction:row-reverse;"]) : null;
});
var ButtonWithIconText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "styled__ButtonWithIconText",
  componentId: "sc-xgnlex-1"
})(["margin:0;font-weight:700;font-size:16px;font-family:'PT Sans',sans-serif;display:flex;align-items:center;", " ", ""], function (props) {
  return props.size === 'xs' || props.size === 'sm' ? (0,styled_components_browser_esm/* css */.iv)(["font-size:14px;"]) : null;
}, function (props) {
  return props.size === 'md' || props.size === 'lg' ? (0,styled_components_browser_esm/* css */.iv)(["font-size:16px;"]) : null;
}); //This wrapper will center the Icon in conjunction with text

var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__IconWrapper",
  componentId: "sc-xgnlex-2"
})(["display:flex;align-items:center;"]);
var Badge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Badge",
  componentId: "sc-xgnlex-3"
})(["background:", ";border-radius:50%;width:24px;height:24px;position:absolute;top:0;right:0;text-align:center;color:", ";"], function (props) {
  return props.theme.colors.theme.primary["default"];
}, function (props) {
  return props.theme.colors.text.white;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/molecules/ButtonWithIcon/index.tsx


var _excluded = ["type", "onClick", "size", "disabled", "children", "variant", "block", "iconName", "rightIcon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









/**
 *  Button Component with selactable icon on name props,
 *
 */
var ButtonWithIcon = function ButtonWithIcon(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      onClick = props.onClick,
      size = props.size,
      disabled = props.disabled,
      children = props.children,
      variant = props.variant,
      block = props.block,
      iconName = props.iconName,
      rightIcon = props.rightIcon,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var _useState = (0,react.useState)(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1]; //access theme outside of styled components


  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)(); //get the size of the icon according to Button Size

  var getIconSize = function getIconSize() {
    if (size === 'xs' || size === 'sm') {
      return 16;
    }

    return 24;
  }; //get the IconColor depending on variant


  var getIconColor = function getIconColor() {
    if (variant === 'primary') {
      return theme.colors.text.white;
    }

    if (variant === 'outline') {
      if (isHovered) {
        return theme.colors.text.primary;
      }

      return theme.colors.text["default"];
    }

    if (variant === 'link') {
      return theme.colors.text.primary;
    }

    if (variant === 'subtle') {
      return theme.colors.text["default"];
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    onMouseEnter: function onMouseEnter() {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    style: {
      display: 'inline'
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, _objectSpread(_objectSpread({
      type: type,
      onClick: onClick,
      size: size,
      variant: variant,
      disabled: disabled,
      block: block
    }, rest), {}, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        rightIcon: rightIcon,
        noText: props.children === undefined,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: iconName,
            size: getIconSize(),
            color: getIconColor()
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIconText, {
          size: size,
          children: children
        })]
      })
    })), props.badge ? /*#__PURE__*/(0,jsx_runtime.jsx)(Badge, {
      children: props.badge
    }) : null]
  });
};

/* harmony default export */ var molecules_ButtonWithIcon = (ButtonWithIcon);

/***/ }),

/***/ 84596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W4": function() { return /* binding */ ButtonWrapper; },
/* harmony export */   "bL": function() { return /* binding */ SelectWrapper; },
/* harmony export */   "n2": function() { return /* binding */ FieldWrapper; },
/* harmony export */   "sN": function() { return /* binding */ SDMContactFormContainer; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14141);

var SDMContactFormContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SDMContactFormstyled__SDMContactFormContainer",
  componentId: "sc-1rldkk8-0"
})(["display:flex;flex-direction:column;"]);
var FieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SDMContactFormstyled__FieldWrapper",
  componentId: "sc-1rldkk8-1"
})(["margin-top:8px;"]);
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SDMContactFormstyled__ButtonWrapper",
  componentId: "sc-1rldkk8-2"
})(["margin-top:16px;"]);
var SelectWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SDMContactFormstyled__SelectWrapper",
  componentId: "sc-1rldkk8-3"
})(["select{border:solid 1px #ccc;width:100%;height:55px;padding-left:28px;padding-right:30px;margin:0;margin-top:5px;}"]);

/***/ }),

/***/ 11587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "IU": function() { return /* binding */ TOSWrapper; },
/* harmony export */   "SJ": function() { return /* binding */ RegisterPageContainer; },
/* harmony export */   "XE": function() { return /* binding */ ReturnWrapper; },
/* harmony export */   "Xy": function() { return /* binding */ StepOneWrapper; },
/* harmony export */   "hm": function() { return /* binding */ ContentInner; }
/* harmony export */ });
/* unused harmony export RegisterStepOneContainer */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14141);
/* harmony import */ var _styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15143);
/* harmony import */ var _atoms_Fonts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73648);



var RegisterPageContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "registerstyled__RegisterPageContainer",
  componentId: "sc-26csxr-0"
})(["height:100%;display:flex;"]);
var ContentInner = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "registerstyled__ContentInner",
  componentId: "sc-26csxr-1"
})(["display:flex;flex-direction:column;align-items:center;flex:1 0 400px;margin:80px 20px 0 20px;@media ", "{margin:80px 16px;}@media ", "{margin:80px 16px;}@media ", "{margin:80px 0;padding:0 20px;}"], _styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.laptop */ .U.laptop, _styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet, _styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.mobile */ .U.mobile);
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_atoms_Fonts__WEBPACK_IMPORTED_MODULE_1__/* .Header1 */ .R6).withConfig({
  displayName: "registerstyled__Title",
  componentId: "sc-26csxr-2"
})(["color:white;margin-bottom:24px;"]);
var RegisterStepOneContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "registerstyled__RegisterStepOneContainer",
  componentId: "sc-26csxr-3"
})(["height:100%;display:flex;"]);
var TOSWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "registerstyled__TOSWrapper",
  componentId: "sc-26csxr-4"
})(["width:100%;display:flex;flex-direction:column;align-items:center;margin:0;@media ", "{max-width:381px;}"], _styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.desktopOnly */ .U.desktopOnly);
var StepOneWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "registerstyled__StepOneWrapper",
  componentId: "sc-26csxr-5"
})(["display:flex;flex-direction:column;align-items:center;flex:1;@media ", "{align-items:initial;width:100%;}"], _styles_breakpoints__WEBPACK_IMPORTED_MODULE_0__/* .device.tablet */ .U.tablet);
var ReturnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "registerstyled__ReturnWrapper",
  componentId: "sc-26csxr-6"
})(["display:flex;justify-content:center;margin-top:24px;"]);

/***/ }),

/***/ 98766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ portal_api_client; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(70594);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(29204);
;// CONCATENATED MODULE: ./src/lib/api/ApiClient.ts







var ApiConfiguration = /*#__PURE__*/(/* unused pure expression or super */ null && (_createClass(function ApiConfiguration() {
  _classCallCheck(this, ApiConfiguration);

  _defineProperty(this, "baseUrl", void 0);
})));

var ApiClient = /*#__PURE__*/function () {
  function ApiClient(apiConfiguration) {
    (0,classCallCheck/* default */.Z)(this, ApiClient);

    (0,defineProperty/* default */.Z)(this, "client", void 0);

    this.client = this.createAxiosClient(apiConfiguration);
  }

  (0,createClass/* default */.Z)(ApiClient, [{
    key: "createAxiosClient",
    value: function createAxiosClient(apiConfiguration) {
      return axios/* default.create */.Z.create({
        baseURL: apiConfiguration.baseUrl,
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true,
        timeout: 60 * 1000
      });
    }
  }, {
    key: "post",
    value: function () {
      var _post = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(path, payload, config) {
        var response, cause, message, _e$response, data;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!config) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return this.client.post(path, payload, config);

              case 4:
                _context.t0 = _context.sent;
                _context.next = 10;
                break;

              case 7:
                _context.next = 9;
                return this.client.post(path, payload);

              case 9:
                _context.t0 = _context.sent;

              case 10:
                response = _context.t0;
                return _context.abrupt("return", response.data);

              case 14:
                _context.prev = 14;
                _context.t1 = _context["catch"](0);
                //TODO: handle network error
                message = 'Could not complete POST Request';

                if (axios/* default.isAxiosError */.Z.isAxiosError(_context.t1)) {
                  data = (_e$response = _context.t1.response) === null || _e$response === void 0 ? void 0 : _e$response.data;

                  if (data !== null && data !== void 0 && data.error) {
                    cause = data.error;
                  }

                  message = _context.t1.message;
                }

                throw Error(message, {
                  cause: cause
                });

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 14]]);
      }));

      function post(_x, _x2, _x3) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(path, config) {
        var response, _error$response;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.client.get(path);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0 instanceof node_modules_axios/* AxiosError */.d7) {
                  console.log("GET error", (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status);
                } //TODO: handle error


                throw _context2.t0;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function get(_x4, _x5) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "patch",
    value: function () {
      var _patch = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(path, payload, config) {
        var response;
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!config) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return this.client.patch(path, payload, config);

              case 4:
                _context3.t0 = _context3.sent;
                _context3.next = 10;
                break;

              case 7:
                _context3.next = 9;
                return this.client.patch(path, payload);

              case 9:
                _context3.t0 = _context3.sent;

              case 10:
                response = _context3.t0;
                return _context3.abrupt("return", response.data);

              case 14:
                _context3.prev = 14;
                _context3.t1 = _context3["catch"](0);
                throw Error('Could not complete PATCH Request');

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 14]]);
      }));

      function patch(_x6, _x7, _x8) {
        return _patch.apply(this, arguments);
      }

      return patch;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(path, config) {
        var response;
        return regenerator_default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                if (!config) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 4;
                return this.client["delete"](path, config);

              case 4:
                _context4.t0 = _context4.sent;
                _context4.next = 10;
                break;

              case 7:
                _context4.next = 9;
                return this.client["delete"](path);

              case 9:
                _context4.t0 = _context4.sent;

              case 10:
                response = _context4.t0;
                return _context4.abrupt("return", response.data);

              case 14:
                _context4.prev = 14;
                _context4.t1 = _context4["catch"](0);
                throw Error('Could not complete DELETE Request');

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 14]]);
      }));

      function _delete(_x9, _x10) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return ApiClient;
}();


;// CONCATENATED MODULE: ./src/lib/api/portal-api/client.ts

var client = new ApiClient({
  baseUrl: "https://api.dealerportal.eyeforce.com"
});
/* harmony default export */ var portal_api_client = (client);

/***/ }),

/***/ 57681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Register; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/axios/axios-client.ts
var axios_client = __webpack_require__(77730);
// EXTERNAL MODULE: ./src/components/containers/index.tsx + 1 modules
var containers = __webpack_require__(96949);
// EXTERNAL MODULE: ./src/components/containers/SideBannerContentContainer.tsx
var SideBannerContentContainer = __webpack_require__(21520);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(71800);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./src/styles/breakpoints/index.ts
var breakpoints = __webpack_require__(15143);
// EXTERNAL MODULE: ./src/components/atoms/Fonts/index.tsx
var Fonts = __webpack_require__(73648);
;// CONCATENATED MODULE: ./src/components/organisms/TermsOfService/TermsOfService.styled.tsx



var TermsOfServiceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TermsOfServicestyled__TermsOfServiceContainer",
  componentId: "sc-1i2gdle-0"
})(["display:flex;flex-direction:column;align-items:center;width:100%;"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* Header2 */.zV).withConfig({
  displayName: "TermsOfServicestyled__Title",
  componentId: "sc-1i2gdle-1"
})(["align-self:flex-start;"]);
var TermsText = styled_components_browser_esm/* default.textarea.withConfig */.ZP.textarea.withConfig({
  displayName: "TermsOfServicestyled__TermsText",
  componentId: "sc-1i2gdle-2"
})(["width:100%;height:446px;color:", ";border:none;background:none;resize:none;font-family:'PT Sans';font-style:normal;font-weight:400;font-size:14px;line-height:20px;scrollbar-width:5px;"], function (props) {
  return props.theme.colors.text["default"];
});
var ButtonsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TermsOfServicestyled__ButtonsWrapper",
  componentId: "sc-1i2gdle-3"
})(["display:flex;width:100%;@media ", "{flex-direction:column;}"], breakpoints/* device.mobile */.U.mobile);
var CancelButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TermsOfServicestyled__CancelButtonWrapper",
  componentId: "sc-1i2gdle-4"
})(["flex:0 0 30%;margin-right:10px;@media ", "{margin-right:0;flex:1;}"], breakpoints/* device.mobile */.U.mobile);
var AgreeButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TermsOfServicestyled__AgreeButtonWrapper",
  componentId: "sc-1i2gdle-5"
})(["flex:1;@media ", "{margin-top:10px;}"], breakpoints/* device.mobile */.U.mobile);
var TermsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TermsOfServicestyled__TermsWrapper",
  componentId: "sc-1i2gdle-6"
})(["width:100%;margin:40px 0;"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/organisms/TermsOfService/TermsOfService.tsx





var TermsOfService = function TermsOfService(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TermsOfServiceContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: "Terms of Service"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TermsWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TermsText, {
        readOnly: true,
        defaultValue: "1. AGREEMENT TO TERMS\n\nThese Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity (\u201Cyou\u201D) and Eyeforce Remote Guarding Solutions (\"Company,\" \u201Cwe,\" \u201Cus,\" or \u201Cour\u201D), concerning your access to and use of the dealerportal.eyeforce.com website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the \u201CSite\u201D). We are registered in Texas, United States and have our registered office at 5611 Hoover St., Houston, TX 77092. You agree that by accessing the Site, you have read, understood, and agreed to be bound by all of these Terms of Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.\n\nSupplemental terms and conditions or documents that may be posted on the Site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Terms of Use at any time and for any reason. We will alert you about any changes by updating the \u201CLast updated\u201D date of these Terms of Use, and you waive any right to receive specific notice of each such change. Please ensure that you check the applicable Terms every time you use our Site so that you understand which Terms apply. You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms of Use by your continued use of the Site after the date such revised Terms of Use are posted.\n\nThe information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose to access the Site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.\n\nThe Site is not tailored to comply with industry-specific regulations (Health Insurance Portability and Accountability Act (HIPAA), Federal Information Security Management Act (FISMA), etc.), so if your interactions would be subjected to such laws, you may not use this Site. You may not use the Site in a way that would violate the Gramm-Leach-Bliley Act (GLBA).\n\nThe Site is intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to use or register for the Site.\n\n\n2. INTELLECTUAL PROPERTY RIGHTS\n\nUnless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the \u201CContent\u201D) and the trademarks, service marks, and logos contained therein (the \u201CMarks\u201D) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, international copyright laws, and international conventions. The Content and the Marks are provided on the Site \u201CAS IS\u201D for your information and personal use only. Except as expressly provided in these Terms of Use, no part of the Site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.\n\nProvided that you are eligible to use the Site, you are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which you have properly gained access solely for your personal, non-commercial use. We reserve all rights not expressly granted to you in and to the Site, the Content and the Marks.\n\n\n3. USER REPRESENTATIONS\n\nBy using the Site, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and promptly update such registration information as necessary; (3) you have the legal capacity and you agree to comply with these Terms of Use; (4) you are not a minor in the jurisdiction in which you reside; (5) you will not access the Site through automated or non-human means, whether through a bot, script, or otherwise; (6) you will not use the Site for any illegal or unauthorized purpose; and (7) your use of the Site will not violate any applicable law or regulation.\n\nIf you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate your account and refuse any and all current or future use of the Site (or any portion thereof).\n\n\n4. USER REGISTRATION\n  \nYou may be required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.\n\n\n5. PROHIBITED ACTIVITIES\n\nYou may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.\n\nAs a user of the Site, you agree not to:\nSystematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.\nTrick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.\nCircumvent, disable, or otherwise interfere with security-related features of the Site, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the Content contained therein.\nDisparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.\nUse any information obtained from the Site in order to harass, abuse, or harm another person.\nMake improper use of our support services or submit false reports of abuse or misconduct.\nUse the Site in a manner inconsistent with any applicable laws or regulations.\nEngage in unauthorized framing of or linking to the Site.\nUpload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party\u2019s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Site.\nEngage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.\nDelete the copyright or other proprietary rights notice from any Content.\nAttempt to impersonate another user or person or use the username of another user.\nUpload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats (\u201Cgifs\u201D), 1\xD71 pixels, web bugs, cookies, or other similar devices (sometimes referred to as \u201Cspyware\u201D or \u201Cpassive collection mechanisms\u201D or \u201Cpcms\u201D).\nInterfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.\nHarass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to you.\nAttempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the Site.\nCopy or adapt the Site\u2019s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.\nExcept as permitted by applicable law, decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.\nExcept as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Site, or using or launching any unauthorized script or other software.\nUse a buying agent or purchasing agent to make purchases on the Site.\nMake any unauthorized use of the Site, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.\nUse the Site as part of any effort to compete with us or otherwise use the Site and/or the Content for any revenue-generating endeavor or commercial enterprise.\nUse the Site to advertise or offer to sell goods and services.\nSell or otherwise transfer your profile.\n\n\n6. USER GENERATED CONTRIBUTIONS\n\nThe Site does not offer users to submit or post content. We may provide you with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, \"Contributions\"). Contributions may be viewable by other users of the Site and through third-party websites. As such, any Contributions you transmit may be treated in accordance with the Site Privacy Policy. When you create or make available any Contributions, you thereby represent and warrant that:\nThe creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your Contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.\nYou are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the Site, and other users of the Site to use your Contributions in any manner contemplated by the Site and these Terms of Use.\nYou have the written consent, release, and/or permission of each and every identifiable individual person in your Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of your Contributions in any manner contemplated by the Site and these Terms of Use.\nYour Contributions are not false, inaccurate, or misleading.\nYour Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.\nYour Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).\nYour Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.\nYour Contributions are not used to harass or threaten (in the legal sense of those terms) any other person and to promote violence against a specific person or class of people.\nYour Contributions do not violate any applicable law, regulation, or rule.\nYour Contributions do not violate the privacy or publicity rights of any third party.\nYour Contributions do not violate any applicable law concerning child pornography, or otherwise intended to protect the health or well-being of minors.\nYour Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.\nYour Contributions do not otherwise violate, or link to material that violates, any provision of these Terms of Use, or any applicable law or regulation.\nAny use of the Site in violation of the foregoing violates these Terms of Use and may result in, among other things, termination or suspension of your rights to use the Site.\n\n\n7. CONTRIBUTION LICENSE\n     \n\nYou agree that we may access, store, process, and use any information and personal data that you provide following the terms of the Privacy Policy and your choices (including settings).\n\nBy submitting suggestions or other feedback regarding the Site, you agree that we can use and share such feedback for any purpose without compensation to you.\n\nWe do not assert any ownership over your Contributions. You retain full ownership of all of your Contributions and any intellectual property rights or other proprietary rights associated with your Contributions. We are not liable for any statements or representations in your Contributions provided by you in any area on the Site. You are solely responsible for your Contributions to the Site and you expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding your Contributions.\n\n\n8. SUBMISSIONS\n\nYou acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding the Site (\"Submissions\") provided by you to us are non-confidential and shall become our sole property. We shall own exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and dissemination of these Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or compensation to you. You hereby waive all moral rights to any such Submissions, and you hereby warrant that any such Submissions are original with you or that you have the right to submit such Submissions. You agree there shall be no recourse against us for any alleged or actual infringement or misappropriation of any proprietary right in your Submissions.\n\n\n9. THIRD-PARTY WEBSITE AND CONTENT\n\nThe Site may contain (or you may be sent via the Site) links to other websites (\"Third-Party Websites\") as well as articles, photographs, text, graphics, pictures, designs, music, sound, video, information, applications, software, and other content or items belonging to or originating from third parties (\"Third-Party Content\"). Such Third-Party Websites and Third-Party Content are not investigated, monitored, or checked for accuracy, appropriateness, or completeness by us, and we are not responsible for any Third-Party Websites accessed through the Site or any Third-Party Content posted on, available through, or installed from the Site, including the content, accuracy, offensiveness, opinions, reliability, privacy practices, or other policies of or contained in the Third-Party Websites or the Third-Party Content. Inclusion of, linking to, or permitting the use or installation of any Third-Party Websites or any Third-Party Content does not imply approval or endorsement thereof by us. If you decide to leave the Site and access the Third-Party Websites or to use or install any Third-Party Content, you do so at your own risk, and you should be aware these Terms of Use no longer govern. You should review the applicable terms and policies, including privacy and data gathering practices, of any website to which you navigate from the Site or relating to any applications you use or install from the Site. Any purchases you make through Third-Party Websites will be through other websites and from other companies, and we take no responsibility whatsoever in relation to such purchases which are exclusively between you and the applicable third party. You agree and acknowledge that we do not endorse the products or services offered on Third-Party Websites and you shall hold us harmless from any harm caused by your purchase of such products or services. Additionally, you shall hold us harmless from any losses sustained by you or harm caused to you relating to or resulting in any way from any Third-Party Content or any contact with Third-Party Websites.\n\n\n10. SITE MANAGEMENT\n\nWe reserve the right, but not the obligation, to: (1) monitor the Site for violations of these Terms of Use; (2) take appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use, including without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your Contributions or any portion thereof; (4) in our sole discretion and without limitation, notice, or liability, to remove from the Site or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; and (5) otherwise manage the Site in a manner designed to protect our rights and property and to facilitate the proper functioning of the Site.\n\n\n11. PRIVACY POLICY\n\nWe care about data privacy and security. By using the Site, you agree to be bound by our Privacy Policy posted on the Site, which is incorporated into these Terms of Use. Please be advised the Site is hosted in the United States. If you access the Site from any other region of the world with laws or other requirements governing personal data collection, use, or disclosure that differ from applicable laws in the United States, then through your continued use of the Site, you are transferring your data to the United States, and you agree to have your data transferred to and processed in the United States.\n\n\n12. TERM AND TERMINATION\n\nThese Terms of Use shall remain in full force and effect while you use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF USE, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF USE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE OR DELETE YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.\n\nIf we terminate or suspend your account for any reason, you are prohibited from registering and creating a new account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on behalf of the third party. In addition to terminating or suspending your account, we reserve the right to take appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.\n\n\n13. MODIFICATIONS AND INTERRUPTIONS\n\nWe reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice. However, we have no obligation to update any information on our Site. We also reserve the right to modify or discontinue all or part of the Site without notice at any time. We will not be liable to you or any third party for any modification, price change, suspension, or discontinuance of the Site.\n\nWe cannot guarantee the Site will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Site, resulting in interruptions, delays, or errors. We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Site at any time or for any reason without notice to you. You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by your inability to access or use the Site during any downtime or discontinuance of the Site. Nothing in these Terms of Use will be construed to obligate us to maintain and support the Site or to supply any corrections, updates, or releases in connection therewith.\n\n\n14. GOVERNING LAW\n\nThese Terms of Use and your use of the Site are governed by and construed in accordance with the laws of the State of Texas applicable to agreements made and to be entirely performed within the State of Texas, without regard to its conflict of law principles.\n\n\n15. DISPUTE RESOLUTION\n\nInformal Negotiations\n\nTo expedite resolution and control the cost of any dispute, controversy, or claim related to these Terms of Use (each \"Dispute\" and collectively, the \u201CDisputes\u201D) brought by either you or us (individually, a \u201CParty\u201D and collectively, the \u201CParties\u201D), the Parties agree to first attempt to negotiate any Dispute (except those Disputes expressly provided below) informally for at least thirty (30) days before initiating arbitration. Such informal negotiations commence upon written notice from one Party to the other Party.\n\nBinding Arbitration\n\nIf the Parties are unable to resolve a Dispute through informal negotiations, the Dispute (except those Disputes expressly excluded below) will be finally and exclusively resolved through binding arbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The arbitration shall be commenced and conducted under the Commercial Arbitration Rules of the American Arbitration Association (\"AAA\") and, where appropriate, the AAA\u2019s Supplementary Procedures for Consumer Related Disputes (\"AAA Consumer Rules\"), both of which are available at the AAA website: www.adr.org. Your arbitration fees and your share of arbitrator compensation shall be governed by the AAA Consumer Rules and, where appropriate, limited by the AAA Consumer Rules. If such costs are determined by the arbitrator to be excessive, we will pay all arbitration fees and expenses. The arbitration may be conducted in person, through the submission of documents, by phone, or online. The arbitrator will make a decision in writing, but need not provide a statement of reasons unless requested by either Party. The arbitrator must follow applicable law, and any award may be challenged if the arbitrator fails to do so. Except where otherwise required by the applicable AAA rules or applicable law, the arbitration will take place in Texas. Except as otherwise provided herein, the Parties may litigate in court to compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate, or enter judgment on the award entered by the arbitrator.\n   \nIf for any reason, a Dispute proceeds in court rather than arbitration, the Dispute shall be commenced or prosecuted in the state and federal courts located in __________, and the Parties hereby consent to, and waive all defenses of lack of personal jurisdiction, and forum non conveniens with respect to venue and jurisdiction in such state and federal courts. Application of the United Nations Convention on Contracts for the International Sale of Goods and the Uniform Computer Information Transaction Act (UCITA) is excluded from these Terms of Use.\n\nIf this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable, and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.\n\nRestrictions\n\nThe Parties agree that any arbitration shall be limited to the Dispute between the Parties individually. To the full extent permitted by law, (a) no arbitration shall be joined with any other proceeding; (b) there is no right or authority for any Dispute to be arbitrated on a class-action basis or to utilize class action procedures; and (c) there is no right or authority for any Dispute to be brought in a purported representative capacity on behalf of the general public or any other persons.\n\nExceptions to Informal Negotiations and Arbitration\n\nThe Parties agree that the following Disputes are not subject to the above provisions concerning informal negotiations and binding arbitration: (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual property rights of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, or unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.\n\n\n16. CORRECTIONS\n\nThere may be information on the Site that contains typographical errors, inaccuracies, or omissions, including descriptions, pricing, availability, and various other information. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Site at any time, without prior notice.\n\n\n17. DISCLAIMER\n\nTHE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE\u2019S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.\n\n\n18. LIMITATIONS OF LIABILITY\n\nIN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE LESSER OF THE AMOUNT PAID, IF ANY, BY YOU TO US OR __________. CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.\n\n\n19. INDEMNIFICATION\n\nYou agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorneys\u2019 fees and expenses, made by any third party due to or arising out of: (1) use of the Site; (2) breach of these Terms of Use; (3) any breach of your representations and warranties set forth in these Terms of Use; (4) your violation of the rights of a third party, including but not limited to intellectual property rights; or (5) any overt harmful act toward any other user of the Site with whom you connected via the Site. Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it.\n\n\n20. USER DATA\n\nWe will maintain certain data that you transmit to the Site for the purpose of managing the performance of the Site, as well as data relating to your use of the Site. Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the Site. You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.\n\n\n21. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES\n\nVisiting the Site, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means.\n\n\n22. CALIFORNIA USERS AND RESIDENTS\n\nIf any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.\n\n\n23. MISCELLANEOUS\n\nThese Terms of Use and any policies or operating rules posted by us on the Site or in respect to the Site constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Use shall not operate as a waiver of such right or provision. These Terms of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control. If any provision or part of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Terms of Use and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment or agency relationship created between you and us as a result of these Terms of Use or use of the Site. You agree that these Terms of Use will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Use and the lack of signing by the parties hereto to execute these Terms of Use.\n\n\n24. CONTACT US\n\nIn order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:\n\nEyeforce Remote Guarding Solutions\n5611 Hoover St.\nHouston, TX 77092\nUnited States\nPhone: 888-393-3672\ninfo@eyeforce.com\n\n"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonsWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CancelButtonWrapper, {
        "data-testid": "CANCEL-BUTTON",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          variant: "outline",
          size: "lg",
          block: true,
          onClick: props.onCancelClick,
          disabled: props.disabled,
          children: "CANCEL"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(AgreeButtonWrapper, {
        "data-testid": "AGREE-BUTTON",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          variant: "primary",
          size: "lg",
          block: true,
          onClick: props.onAgreeClick,
          disabled: props.disabled,
          children: "I AGREE, CREATE ACCOUNT"
        })
      })]
    })]
  });
};

/* harmony default export */ var TermsOfService_TermsOfService = (TermsOfService);
;// CONCATENATED MODULE: ./src/components/organisms/TermsOfService/index.tsx

/* harmony default export */ var organisms_TermsOfService = (TermsOfService_TermsOfService);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/config/sitemap.ts
var sitemap = __webpack_require__(65723);
// EXTERNAL MODULE: ./src/components/molecules/ButtonWithIcon/index.tsx + 1 modules
var ButtonWithIcon = __webpack_require__(7288);
// EXTERNAL MODULE: ./src/components/molecules/LogoWithTitle/index.tsx + 1 modules
var LogoWithTitle = __webpack_require__(95259);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/lib/api/portal-api/client.ts + 1 modules
var client = __webpack_require__(98766);
;// CONCATENATED MODULE: ./src/lib/api/portal-api/user/checkExists.ts



var checkUserExists = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(username, email) {
    var data;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client/* default.post */.Z.post('/user/exists', {
              username: username,
              email: email
            });

          case 3:
            data = _context.sent;

            if (!(data.data === undefined)) {
              _context.next = 6;
              break;
            }

            throw new Error('API Error');

          case 6:
            return _context.abrupt("return", data.data);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);

          case 11:
            throw Error('Could not check username.');

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function checkUserExists(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./src/components/atoms/TextInput/index.tsx
var TextInput = __webpack_require__(74398);
// EXTERNAL MODULE: ./src/components/organisms/PasswordField/PasswordField.tsx + 1 modules
var PasswordField = __webpack_require__(60988);
;// CONCATENATED MODULE: ./src/components/organisms/RegisterForm/register.styled.tsx


var RegisterFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "registerstyled__RegisterFormContainer",
  componentId: "sc-kezy0i-0"
})([""]);
var DoubleColumnFields = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "registerstyled__DoubleColumnFields",
  componentId: "sc-kezy0i-1"
})(["display:flex;gap:24px;margin:0;@media ", "{gap:0px;flex-direction:column;margin:0;}"], breakpoints/* device.tablet */.U.tablet);
var DoubleColumnFieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "registerstyled__DoubleColumnFieldWrapper",
  componentId: "sc-kezy0i-2"
})(["margin:0;flex:1;@media ", "{:first-child{margin-bottom:24px;}display:flex;}"], breakpoints/* device.tablet */.U.tablet);
var FieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "registerstyled__FieldWrapper",
  componentId: "sc-kezy0i-3"
})(["margin:24px 0;flex:1 1;display:flex;"]);
// EXTERNAL MODULE: ./src/components/organisms/SDMContactForm/SDMContactForm.styled.tsx
var SDMContactForm_styled = __webpack_require__(84596);
// EXTERNAL MODULE: ./src/components/atoms/TextInput/styled.tsx
var styled = __webpack_require__(25018);
;// CONCATENATED MODULE: ./src/components/organisms/RegisterForm/registerform.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












/*TODO: We should lift the <Formik> component up to the parent. This will make it easier to set network errors and test in storybook using Formik Addon
https://github.com/bbbtech/storybook-formik
*/



var registerFormSchema = es/* object */.Ry().shape({
  username: es/* string */.Z_().required('Username is required').matches(/^[a-zA-Z\_\-0-9]{6,64}$/, {
    excludeEmptyString: false,
    message: "Please enter a valid username. \n          Must be at least 6 characters. \n          Letters, numbers, dashes, and underscores only."
  }).test('usernameExists', 'Username already exists', /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(value) {
      var usernameExists;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              if (value) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return checkUserExists(value);

            case 6:
              usernameExists = _context.sent;

              if (!usernameExists) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", this.createError({
                message: 'Username already exists',
                path: 'username'
              }));

            case 9:
              return _context.abrupt("return", true);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              console.log(_context.t0);
              return _context.abrupt("return", false);

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t1 = _context["catch"](0);
              console.log(_context.t1);
              return _context.abrupt("return", false);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 18], [3, 12]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()),
  email: es/* string */.Z_().email('Must be a valid email').required('Email is required').test('emailExists', 'Email is invalid', /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(value) {
      var exists;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (value) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", false);

            case 3:
              _context2.prev = 3;
              _context2.next = 6;
              return checkUserExists(undefined, value);

            case 6:
              exists = _context2.sent;

              if (!exists) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", this.createError({
                message: 'Email already exists',
                path: 'email'
              }));

            case 9:
              return _context2.abrupt("return", true);

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](3);
              //TODO: handle error
              console.log(_context2.t0);
              return _context2.abrupt("return", false);

            case 16:
              _context2.next = 22;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t1 = _context2["catch"](0);
              console.log(_context2.t1);
              return _context2.abrupt("return", false);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 18], [3, 12]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
  companyName: es/* string */.Z_().required('Company Name is required'),
  firstName: es/* string */.Z_().required('First name is required'),
  lastName: es/* string */.Z_().required('Last name is required'),
  password: es/* string */.Z_().required('Password is required'),
  salesRep: es/* string */.Z_().optional(),
  confirmPassword: es/* string */.Z_().required('Please confirm password').oneOf([es/* ref */.iH('password'), null], 'Passwords must match')
});

var RegisterForm = function RegisterForm(props) {
  var _props$initialValues;

  var _useState = (0,react.useState)(false),
      showingPassword = _useState[0],
      setShowingPassword = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(RegisterFormContainer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
      onSubmit: function onSubmit(values) {
        props.onSubmit(values);
      },
      initialValues: (_props$initialValues = props.initialValues) !== null && _props$initialValues !== void 0 ? _props$initialValues : {
        username: '',
        email: '',
        companyName: '',
        firstName: '',
        lastName: '',
        password: '',
        confirmPassword: '',
        salesRep: 'None Selected'
      },
      validationSchema: registerFormSchema,
      validateOnChange: false,
      validateOnBlur: false,
      children: function children(_ref3) {
        var _props$buttonLabel;

        var errors = _ref3.errors,
            isSubmitting = _ref3.isSubmitting;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
              name: "username",
              children: function children(field) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread(_objectSpread({
                  name: "username",
                  size: 'lg'
                }, field), {}, {
                  placeholder: 'Set Your Username',
                  type: 'text',
                  errorMessage: errors.username
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
              name: "email",
              children: function children(field) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread(_objectSpread({
                  name: "email",
                  size: 'lg'
                }, field), {}, {
                  placeholder: 'Your Email',
                  type: 'text',
                  errorMessage: errors.email
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
              name: "companyName",
              children: function children(field) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread(_objectSpread({
                  name: "companyName",
                  size: 'lg'
                }, field), {}, {
                  placeholder: 'Company Name',
                  type: 'text',
                  errorMessage: errors.companyName
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DoubleColumnFields, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DoubleColumnFieldWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                name: "firstName",
                children: function children(field) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread(_objectSpread({}, field), {}, {
                    name: "firstName",
                    size: 'lg',
                    placeholder: 'First Name',
                    type: 'text',
                    errorMessage: errors.firstName
                  }));
                }
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DoubleColumnFieldWrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                name: "lastName",
                children: function children(field) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread(_objectSpread({
                    name: "lastName",
                    size: 'lg'
                  }, field), {}, {
                    placeholder: 'Last Name',
                    type: 'text',
                    errorMessage: errors.lastName
                  }));
                }
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
              name: "password",
              children: function children(field) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordField/* default */.Z, _objectSpread(_objectSpread({}, field), {}, {
                  name: "password",
                  size: 'lg',
                  placeholder: 'Set Password',
                  isEnabled: showingPassword,
                  onIconClick: function onIconClick() {
                    setShowingPassword(!showingPassword);
                  },
                  errorMessage: errors.password
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
              name: "confirmPassword",
              children: function children(field) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordField/* default */.Z, _objectSpread(_objectSpread({}, field), {}, {
                  name: "confirmPassword",
                  size: 'lg',
                  placeholder: 'Confirm Password',
                  isEnabled: showingPassword,
                  onIconClick: function onIconClick() {
                    setShowingPassword(!showingPassword);
                  },
                  errorMessage: errors.confirmPassword
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
            style: {
              flexDirection: 'column'
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SDMContactForm_styled/* SelectWrapper */.bL, {
              children: [errors.salesRep && /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* StyledErrorMessage */.Vv, {
                children: errors.salesRep
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                name: "salesRep",
                children: function children(field) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
                    onChange: function onChange(e) {
                      return field.form.setFieldValue('salesRep', e.target.value);
                    },
                    value: field.field.value,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "None Selected",
                      children: "Who is your sales representative?"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Bret Anderson",
                      children: "Bret Anderson"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Cameron Richter",
                      children: "Cameron Richter"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Connor Miller",
                      children: "Connor Miller"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Cort Dixon",
                      children: "Cort Dixon"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Danny Youngerman",
                      children: "Danny Youngerman"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Ken D'Arterio",
                      children: "Ken D\u2019Arterio"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Lewis Jacobson",
                      children: "Lewis Jacobson"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Matt Brandon",
                      children: "Matt Brandon"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Mike Putman",
                      children: "Mike Putman"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Scott Gould",
                      children: "Scott Gould"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Seth Anderson",
                      children: "Seth Anderson"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Seth Barcus",
                      children: "Seth Barcus"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "Troy Iverson",
                      children: "Troy Iverson"
                    })]
                  });
                }
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "primary",
            type: "submit",
            size: "lg",
            block: true,
            disabled: isSubmitting,
            children: (_props$buttonLabel = props.buttonLabel) !== null && _props$buttonLabel !== void 0 ? _props$buttonLabel : 'CONTINUE'
          })]
        });
      }
    })
  });
};

/* harmony default export */ var registerform = (RegisterForm);
// EXTERNAL MODULE: ./src/components/pages/Register/register.styled.tsx
var register_styled = __webpack_require__(11587);
;// CONCATENATED MODULE: ./src/components/pages/Register/components/step-one.tsx









var RegisterStepOne = function RegisterStepOne(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(register_styled/* StepOneWrapper */.Xy, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LogoWithTitle/* default */.Z, {
      title: "Create an Account"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(registerform, {
      onSubmit: function onSubmit(values) {
        props.onContinue(values);
      },
      initialValues: props.initialValues
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(register_styled/* ReturnWrapper */.XE, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: sitemap/* SITEMAP.LOGIN */.a.LOGIN,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
          size: 'lg',
          variant: 'subtle',
          iconName: 'leftArrow',
          children: "RETURN TO LOGIN"
        })
      })
    })]
  });
};

/* harmony default export */ var step_one = (RegisterStepOne);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/pages/Register/register.tsx



var _excluded = ["confirmPassword"];

function register_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function register_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? register_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : register_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var RegisterPage = function RegisterPage(props) {
  var _props$defaultStep;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)({
    step: (_props$defaultStep = props.defaultStep) !== null && _props$defaultStep !== void 0 ? _props$defaultStep : 1,
    values: {
      username: '',
      email: '',
      companyName: '',
      firstName: '',
      lastName: '',
      password: '',
      confirmPassword: '',
      salesRep: ''
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  var mutation = (0,useMutation/* useMutation */.D)({
    mutationFn: function mutationFn(registerInput) {
      return axios_client/* api.post */.h.post('/auth/register', registerInput);
    },
    onSuccess: function () {
      var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // const res = await api.post('/auth/login', {
                //   username: state.values.email,
                //   password: state.values.password,
                // });
                console.log("success");
                router.push('/auth/pending-approval');

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(register_styled/* RegisterPageContainer */.SJ, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SideBannerContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(register_styled/* ContentInner */.hm, {
        children: [state.step === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(step_one, {
          initialValues: state.values,
          onContinue: function onContinue(values) {
            return setState({
              values: values,
              step: 2
            });
          }
        }) : null, state.step === 2 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(register_styled/* TOSWrapper */.IU, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(organisms_TermsOfService, {
            onCancelClick: function onCancelClick() {
              return setState(register_objectSpread(register_objectSpread({}, state), {}, {
                step: 1
              }));
            },
            onAgreeClick: function onAgreeClick() {
              var _state$values = state.values,
                  confirmPassword = _state$values.confirmPassword,
                  registerInput = (0,objectWithoutProperties/* default */.Z)(_state$values, _excluded);

              mutation.mutate(registerInput);
            },
            disabled: mutation.isLoading || mutation.isSuccess
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            style: {
              marginTop: 80
            },
            src: "https://public.dealerportal.eyeforce.com/images/logo.png",
            width: 157,
            height: 32,
            alt: 'logo'
          })]
        }) : null]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers/* SideBannerContainer */.R, {
      maxImageWidth: 700,
      style: {
        backgroundImage: "url(/assets/images/side-banners/login-banner.png)"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(register_styled/* Title */.Dx, {
        children: ["THE FUTURE OF SECURITY", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "IS ADVANCED", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "VIDEO MONITORING"]
      })
    })]
  });
};

/* harmony default export */ var register = (RegisterPage);
;// CONCATENATED MODULE: ./src/pages/auth/register.tsx





var __N_SSP = true;
function Register() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Dealer Portal - Register"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(register, {})]
  });
}

/***/ }),

/***/ 16659:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/register",
      function () {
        return __webpack_require__(57681);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,5675,753,4231,1336,362,9774,2888,179], function() { return __webpack_exec__(16659); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);